import axios from 'axios'
import { getEndpoint } from '../../../features/common/backend/endpoints'

export const generateExcel = async (fromDate, toDate) => {
 
  const endpoint = getEndpoint('PRESUPUESTADOR')

  const res = await axios(`${endpoint}/generateExcel?desde=${fromDate}&hasta=${toDate}`, {
    method: 'GET',
    timeout: 300000, // 5 minutos
  })

  return res.data
}
